import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Error = styled.p`
  color: ${({ theme }) => theme.colors.error};
  text-align: center;
`;
